export enum CategorySorting {
  Featured = "featured",
  ClosingTimeFirstToLast = "closing_time_first_to_last",
  ClosingTimeLastToFirst = "closing_time_last_to_first",
  StartingTimeFirstToLast = "starting_time_first_to_last",
  StartingTimeLastToFirst = "starting_time_last_to_first",
}

export enum CategoryTabs {
  Live = "live",
  Historical = "historical",
  Upcoming = "upcoming",
}
